module.exports = __webpack_public_path__ + "static/media/vegitables_27.ccd05b08.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_27.csv
// module id = 610
// module chunks = 0